import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { Form, useLoaderData } from "@remix-run/react";
import { useEffect } from "react";
import { IMG_URL } from "../helpers/def";
import { NavLink } from "@remix-run/react";
import { getAllNews, getNewsByHref, getNewsTags} from "../controllers/news";
import { json, redirect } from "@remix-run/node";
import parse from 'html-react-parser';
import moment from "moment/moment";
import { getNewestMotor } from "../controllers/models";
import { getNewsCats } from "../controllers/category";
//styles
import styles1 from '~/assets/css/uikit.min.css';
import styles2 from '~/assets/css/slick.css';
import styles3 from '~/assets/css/slick-theme.css';
import styles4 from '~/assets/css/ion.rangeSlider.css';
import styles5 from '~/assets/css/main.css';
const mongoose =require('mongoose');
const useScript = (src,condition) => {  
    useEffect(() => {
            const tag = document.createElement('script');
            tag.async = condition;
            tag.src = src;
            document.body.appendChild(tag);            
            return () => {
              document.body.removeChild(tag);
            }      
    }, [src])  
  }
export default function Haberler(){
    useScript('/assets/js/jquery.min.js',false);
  useScript('/assets/js/uikit.min.js',false);
  useScript('/assets/js/uikit-icons.min.js',false);
  useScript('/assets/js/fontawesome.all.min.js',false);
  useScript('/assets/js/slick.min.js',false);
  useScript('/assets/js/ion.rangeSlider.min.js',false);
  useScript('/assets/js/main.js',false);
  const data =useLoaderData();
  const sliderImage = {
    backgroundImage: 'url('+IMG_URL+'mc/1920/950/6/sliders/'+data?.page.slider.split('æ')[0]+')'
    }  
    return(
        <div className="page-wrapper">
        <Header />
        <main className="page-main">
      <div className="section-hero">
        <div className="section-hero__bg" style={sliderImage}>
          <div className="uk-container">
            <div className="section-hero__content">
              <div className="section-hero__title"> <span>{data?.page.slider.split('æ')[1]}</span>
                <div className="uk-h1">{data?.page.slider.split('æ')[2]}</div>
              </div>
              <div className="section-hero__breadcrumb">
                <ul className="uk-breadcrumb">
                  <li><NavLink to="/">Ana Sayfa</NavLink></li>
                  <li><NavLink to="/haberler">Haberler</NavLink></li>
                  <li> <span>{data.page.title}</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
      <div className="uk-section-large uk-container">
          <div className="uk-grid" data-uk-grid>
          <div className="uk-width-2-3@m">
                            <article className="article">
                                <div className="article__media"> <NavLink to={'/haberler/'+data.page.href}><img className="article__img" src={IMG_URL+'mc/750/400/6/bodyphoto/'+data.page.photo} alt={data.page.title}/></NavLink><img className="article__avatar" src="/metam-logo.png" alt="Metam Alanya Honda"/></div>
                                <div className="article__info">
                                    <div className="article__author"><img src="/assets/img/icons/author.svg" alt="icon"/><span>Alanya Honda</span></div>
                                    <div className="article__date"> <img src="/assets/img/icons/calendar.svg" alt="icon"/><span>{moment(data.page.updatedAt).format('d.MM.yyyy')}</span></div>
                                    <div className="article__category"><img src="/assets/img/icons/category.svg" alt="icon"/><span>{data.page.category}</span></div>
                                </div>
                                <div className="article__title">{data.page.title}</div>
                                <div className="article__content">
                                {parse(data.page?.body||'')}
                                                                </div>
                                <div className="article__bottom">
                                    <div className="article__tags"> <b>Tags:</b>
                                        <ul>
                                        {data.page.tags.split(',').map((tags,indexs)=>(
                                                <li key={indexs}><NavLink to={'/haberler/tag/'+tags}>{tags}</NavLink></li>                                            
                                        ))}
                                        </ul>
                                    </div>
                                </div>
                            </article>
                        </div>
            <div className="uk-width-1-3@m">
              <aside className="sidebar">
                <div className="widjet widjet--search">
                  <div className="widjet__title">
                    <div className="uk-h4">Haber Ara</div>
                  </div>
                  <div className="widjet__content">
                    <Form method="post" className="uk-search uk-search-default uk-width-1-1"><span className="uk-search-icon-flip" data-uk-search-icon></span><input name="param" required className="uk-search-input uk-form-large" type="search" placeholder="Aranacak Kelime..."/></Form>
                  </div>
                </div>
                <div className="widjet widjet--categories">
                  <div className="widjet__title">
                    <div className="uk-h4">Kategoriler</div>
                  </div>
                  <div className="widjet__content">
                    <ul className="categories-list">
                    {data.cats?.map((cat,index)=>(
                      <li key={index} className="categories-item"><NavLink className="categories-item__link" to={'/haberler/cat/'+cat.title}><span className="categories-item__title"><span data-uk-icon="triangle-right"></span>{cat.title}</span><span className="categories-item__count">{'('+data.news.filter(item => item.category === cat.title).length+')'}</span></NavLink></li>

                    ))}
                     </ul>
                  </div>
                </div>
                <div className="widjet widjet--recent-posts">
                  <div className="widjet__title">
                    <div className="uk-h4">En yeni haberler</div>
                  </div>
                  <div className="widjet__content">
                    <ul className="latest-news-list">
                    {data.news?.slice(0,3).map((news,index)=>(
                     <li key={index}>
                     <div className="latest-news-item">
                       <div className="latest-news-item__thumb"><img src={IMG_URL+'mc/70/70/6/news/'+news.cover} alt={news.title}/></div>
                       <div className="latest-news-item__info"><NavLink className="latest-news-item__title" to={'/haberler/'+news.href}>{news.title}</NavLink>
                         <div className="latest-news-item__date"> <img src="/assets/img/icons/calendar.svg" alt={news.title}/>{moment(news.updatedAt).format('d.MM.yyyy')}</div>
                       </div>
                     </div>
                   </li>
                    ))}
                    </ul>
                  </div>
                </div>
                <div className="widjet widjet--recent-posts">
                  <div className="widjet__title">
                    <div className="uk-h4">Konu Başlıkları</div>
                  </div>
                  <div className="widjet__content">
                    <ul className="tags-cloud">
                    {data.tags.map((tags,indexs)=>(
                      tags.split(',').map((tag,index)=>(
                        <li key={index}><NavLink to={'/haberler/tag/'+tag}>{tag}</NavLink></li>
                      ))                      
                    ))}
                    </ul>
                  </div>
                </div>
                <div className="widjet widjet--latest-motorcycles">
                  <div className="widjet__title">
                    <div className="uk-h4">En Yeni Modeller</div>
                  </div>
                  <div className="widjet__content">
                    <div className="latest-motorcycles">
                      <div className="latest-motorcycles__media">
                        <div className="uk-position-relative uk-light" tabIndex="-1" data-uk-slider>
                          <ul className="uk-slider-items uk-child-width-1-1">
                          {data?.motor.gallerry.split('æ').map((picture, index) => (
                            <li key={index}><img className="uk-width-1-1" src={IMG_URL+'mc/360/300/6/gallery/'+picture} alt={data?.motor.title}/></li>
                          ))}
                          </ul><a className="uk-position-center-left" href="#" data-uk-slidenav-previous data-uk-slider-item="previous"></a><a className="uk-position-center-right" href="#" data-uk-slidenav-next data-uk-slider-item="next"> </a>
                        </div>
                      </div>
                      <div className="latest-motorcycles__body">
                        <div className="latest-motorcycles__title"> <NavLink to={'/honda-model/'+data?.motor.title.replaceAll(' ','-')}>{data?.motor.title}</NavLink></div>
                        <div className="latest-motorcycles__price"> <span>Honda</span></div>
                        <div className="latest-motorcycles__info">
                          <div className="latest-motorcycles__model"><span>Hacim: {data?.motor.enginecc}</span></div>
                          <div className="latest-motorcycles__type"> <span>Tip: {data?.motor.category}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </main>
        <Footer news={data.news?.slice(0,3)} />          
    </div>
    
        
    )
}
export const loader= async ({params}) => {
    await mongoose.connect(process.env.DATABASE_URL);
    const [page, news,tags,motor,cats,two] = await Promise.all([
      getNewsByHref(params.href),
      getAllNews(),
      getNewsTags(),
      getNewestMotor(),
      getNewsCats()    
   ]);
   return json({ page,news,tags,motor,cats});  
  }
  export function meta({data}){
     return{
      title:data.page.title,
      description:data.page.seoD,
      keywords:data.page.seoK
    };
  }
  export async function action({request}){
    const formData=await request.formData();
    const messageData=Object.fromEntries(formData);
    return redirect('/haberler/search/'+messageData.param);
    }
    export function links(){
      return [
        {rel:'stylesheet',href:styles1},
        {rel:'stylesheet',href:styles2},
        {rel:'stylesheet',href:styles3},
        {rel:'stylesheet',href:styles4},
        {rel:'stylesheet',href:styles5}
      ]
    }